import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@shared/guards/is-authenticated.guard';
import { isNotAuthenticatedGuard } from '@shared/guards/is-not-authenticated.guard';

import { UserLoginComponent } from './modules/user/pages/user-login/user-login.component';
import { MainPageComponent } from './core/pages/main-page/main-page.component';

import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { ForbiddenPageComponent } from './core/pages/forbidden-page/forbidden-page.component';
import { RouteNames } from './route-names';
import { WelcomeLayoutComponent } from './core/layouts/welcome-layout/welcome-layout.component';
import { NotFoundPageComponent } from './core/pages/not-found-page/not-found-page.component';
import { HomeComponent } from './modules/home/home.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: WelcomeLayoutComponent,
    children: [
      {
        path: '',
        component: MainPageComponent,
        title: 'Главная страница',
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: RouteNames.LOGIN_PAGE,
        component: UserLoginComponent,
        title: 'Войти',
        canActivate: [isNotAuthenticatedGuard],
      },
      {
        path: RouteNames.HOME,
        title: 'Домашняя страница',
        canActivate: [isAuthenticatedGuard],
        component: HomeComponent,
      },

      {
        path: RouteNames.JOURNAL_PAGE,
        title: 'Журнал',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/journal/routes').then(mod => mod.JOURNAL_ROUTES),
      },

      {
        path: RouteNames.FORBIDDEN_PAGE,
        title: 'Доступ запрещен',
        component: ForbiddenPageComponent,
      },
      {
        path: RouteNames.NOT_FOUND_PAGE,
        title: 'Страница не найдена',
        component: NotFoundPageComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: RouteNames.HOME,
  },
];
